var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "memberDocModal",
      "modal-class": "client-details-modal",
      "centered": "",
      "size": "lg",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.getData
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-clients-header"
        }, [_c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', {
    ref: "memberDocContainer",
    attrs: {
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "view-clients-modal-content"
  }, [_vm.user ? _c('h6', [_vm._v(" " + _vm._s(_vm.user.name) + " - " + _vm._s(_vm.member && _vm.member.policy_id ? _vm.member.policy_id : "") + " ")]) : _vm._e(), _c('p', {
    staticClass: "email-address"
  }, [_vm._v(_vm._s(_vm.user.email))]), _c('ul', {
    staticClass: "client-docs"
  }, [!_vm.files ? _c('li', [_c('no-content', {
    attrs: {
      "text": "No files found."
    }
  })], 1) : _vm._e(), _vm._l(_vm.filteredFiles, function (file, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "d-inline me-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.data,
        expression: "form.data"
      }],
      attrs: {
        "type": "checkbox",
        "id": "checkbox-1",
        "name": "checkbox-1"
      },
      domProps: {
        "value": file,
        "checked": Array.isArray(_vm.form.data) ? _vm._i(_vm.form.data, file) > -1 : _vm.form.data
      },
      on: {
        "change": function change($event) {
          var $$a = _vm.form.data,
              $$el = $event.target,
              $$c = $$el.checked ? true : false;

          if (Array.isArray($$a)) {
            var $$v = file,
                $$i = _vm._i($$a, $$v);

            if ($$el.checked) {
              $$i < 0 && _vm.$set(_vm.form, "data", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(_vm.form, "data", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(_vm.form, "data", $$c);
          }
        }
      }
    })]), _c('a', {
      attrs: {
        "href": file.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(file.filename))])]);
  })], 2), _vm.checkPlan() ? _c('p', {
    staticClass: "new-rates"
  }, [_vm._v(" New Rate for L713, NAWU Plans as of January 1st, 2026 "), _c('router-link', {
    staticClass: "route-link",
    staticStyle: {
      "display": "block",
      "margin-bottom": "4%"
    },
    attrs: {
      "target": "_blank",
      "to": '/document-view-details/' + _vm.base64Encode(_vm.member)
    }
  }, [_vm._v("Click here to view.")])], 1) : _vm._e(), _vm.checkSolicticPlan() ? _c('p', {
    staticClass: "new-rates"
  }, [_vm._v(" New Rate for Solistic Plan as of June 1, 2025 "), _c('router-link', {
    staticClass: "route-link",
    staticStyle: {
      "display": "block",
      "margin-bottom": "4%"
    },
    attrs: {
      "target": "_blank",
      "to": {
        name: 'SolisticViewCard',
        params: {
          policyId: _vm.encodePolicyId(_vm.member)
        }
      }
    }
  }, [_vm._v("Click here to view.")])], 1) : _vm._e(), _c('button', {
    staticClass: "btn univ-btn btn-secondary",
    attrs: {
      "type": "button",
      "disabled": _vm.isDisable
    },
    on: {
      "click": _vm.sendCardEmail
    }
  }, [_vm._v(" " + _vm._s(_vm.isSend ? " Sending Card" : " Send Card") + " ")])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }